import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Global from './components/global/index'

Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.global = Global.GLOBAL
document.title = Global.GLOBAL.appName
new Vue({
  render: h => h(App),
}).$mount('#app')

